/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Improve, personalize, and expand our services`)
};

const es_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar, personalizar y expandir nuestros servicios`)
};

const de_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Dienste zu verbessern, zu personalisieren und zu erweitern`)
};

const nl_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze diensten te verbeteren, personaliseren en uit te breiden`)
};

const fr_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Améliorer, personnaliser et étendre nos services`)
};

const it_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliorare, personalizzare e ampliare i nostri servizi`)
};

const pt_br2_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhorar, personalizar e expandir nossos serviços`)
};

const pt_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhorar, personalizar e expandir os nossos serviços`)
};

const ja_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスの改善、パーソナライズ、拡張`)
};

const zh_privacy_use_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`改进、个性化和扩展我们的服务`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_use_2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_use_2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_use_2", locale)
	if (locale === "en") return en_privacy_use_2(inputs)
	if (locale === "es") return es_privacy_use_2(inputs)
	if (locale === "de") return de_privacy_use_2(inputs)
	if (locale === "nl") return nl_privacy_use_2(inputs)
	if (locale === "fr") return fr_privacy_use_2(inputs)
	if (locale === "it") return it_privacy_use_2(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_use_2(inputs)
	if (locale === "pt") return pt_privacy_use_2(inputs)
	if (locale === "ja") return ja_privacy_use_2(inputs)
	return zh_privacy_use_2(inputs)
};